import { DataSourceMode, Layout, SaveButton, SlideoutDecorator, SlideoutDecoratorProps, TableRow, Toast } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { PlanningLinkedMoves } from "./PlanningLinkedMoves";
import { CommonDialogs } from "@mcleod/common";

interface LinkedMoveSlideoutProps {
    selectedRows?: TableRow[];
    linkedId?: string;
    linkedAction: LinkedAction
}

export enum LinkedAction {
    ADD = "add",
    EDIT = "edit"
}

export class LinkedMoveSlideout {

    constructor(props: LinkedMoveSlideoutProps, sldProps?: Partial<SlideoutDecoratorProps>) {
        this.slideUp(props, sldProps);
    }

    private slideUp(props: LinkedMoveSlideoutProps, sldProps?: Partial<SlideoutDecoratorProps>) {
        const { selectedRows, linkedId, linkedAction } = props;
        const layout = Layout.getLayout("lme/dispatch/planning/PlanningLinkedMoves") as PlanningLinkedMoves;
        const saveButton = SaveButton.create({ caption: "Save", rowBreak: false,
            disabledTooltip: "You cannot save this record because nothing has changed.",
            onClick: () => {
                saveButton.busy = true;
                layout.performSave().then((res) => {
                    if (res) {
                        layout.slideOut().then(() => {
                            Toast.showSuccessToast(linkedAction == LinkedAction.ADD ? "Movements Linked Successfully" : "Updated Linked Movements Successfully");
                            if (selectedRows)
                                selectedRows[0].table.selectedRows = [];
                        });
                    }
                }).finally(() => saveButton.busy = false);
            }
        });
        new SlideoutDecorator({
            layout,
            title: linkedAction == LinkedAction.ADD ? "Create Linked Moves" : "Edit Linked Moves",
            displayOverlay: true,
            overlayProps: { greyedBackground: true, closeOnClickOff: false },
            contentProps: { padding: 12 },
            width: "75%",
            fillVerticalSpace: true,
            addlComponents: [saveButton],
            layoutLoadListeners: async () => {
                const buildModelRows = (selectedRows: TableRow[], sequenceNum: number = 1) => {
                    return selectedRows.map((row: TableRow) => {
                        const modelRow = row.data as ModelRow;
                        modelRow.set("linked_sequence", sequenceNum++);
                        return new ModelRow(layout.sourceAvailableMove.url, true, modelRow.data);
                    });
                }
                let saveEnabled: boolean = linkedAction == LinkedAction.ADD;
                const rowsToAdd = selectedRows != null ? selectedRows.filter(r => r.data.get("linked_id") == null) : [];

                if (LinkedAction.ADD == linkedAction) {
                    const mappedData = buildModelRows(rowsToAdd);
                    layout.sourceAvailableMove.setRowsAndMode(DataSourceMode.ADD, mappedData);
                } else {
                    layout.mainDataSource = layout.tableEquipmentAssignments.dataSource = layout.sourcePlanningMovementStops;
                    await layout.mainDataSource.search({ linked_id: linkedId });
                    if (selectedRows != null && rowsToAdd.length < selectedRows.length) {
                        const addedData = buildModelRows(rowsToAdd, layout.mainDataSource.rowCount+1);
                        const allData = layout.mainDataSource.data.concat(addedData);
                        layout.mainDataSource.setRowsAndMode(DataSourceMode.ADD, allData);
                        saveEnabled = true;
                    }
                }

                layout.setup(linkedAction);
                layout.checkboxLinkAll.checked = linkedAction == LinkedAction.ADD;
                layout.mainDataSource.addHasChangedComponent(saveButton);
                saveButton.enabled = saveEnabled;
            },
            onClose: async (cancelled: boolean) => {
                if (LinkedAction.EDIT == linkedAction) {
                    if (layout.mainDataSource.hasChanged()) {
                        const checkSaved = await CommonDialogs.showYesNo("Are you sure you want to discard the changes made to the linked moves list and exit?");
                        if (!checkSaved || checkSaved == undefined) {
                            return;
                        }
                    }
                }
                layout.slideOut();
            },
            ...sldProps
        });
    }

}
